<div class="dialog-title">
  <span>Update Roles</span>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>


<div matDialogContent>
  <form [formGroup]="checkboxGroup">
    @for (checkbox of checkboxControls; track checkbox; let i = $index) {
      <mat-checkbox  [formControl]="checkbox">
        {{ selectableRoles[i] | roleName }}
      </mat-checkbox>
    }
  </form>
</div>


<div matDialogActions class="dialog-actions">
  <button mat-flat-button color="primary" (click)="updateRoles()">
    Submit
  </button>
</div>
